import BSCornTortillaProduct from 'models/BSCornTortillaProduct'

export const brandNameOptions = [
  {
    value: '',
    label: 'Brand Name',
    isDisabled: true,
  },
  { value: 'Chavez Supermarket', label: 'Chavez Supermarket' },
  { value: 'Don Pancho', label: 'Don Pancho' },
  { value: 'Early On', label: 'Early On' },
  { value: 'El Comal', label: 'El Comal' },
  { value: 'El Super', label: 'El Super' },
  { value: 'Essential Everyday', label: 'Essential Everyday' },
  { value: 'First Street', label: 'First Street' },
  { value: 'Goya', label: 'Goya' },
  { value: 'Great Value', label: 'Great Value' },
  { value: 'Guerrero', label: 'Guerrero' },
  { value: 'IGA', label: 'IGA' },
  { value: 'La Banderita', label: 'La Banderita' },
  { value: 'La Burrita', label: 'La Burrita' },
  { value: 'La Tapatia', label: 'La Tapatia' },
  { value: 'Mission', label: 'Mission' },
  { value: 'Ozuna', label: 'Ozuna' },
  { value: "Raley's", label: "Raley's" },
  {
    value: 'Rancho Gonzalez',
    label: 'Rancho Gonzalez by Northgate Market',
  },
  { value: "Romero's", label: "Romero's" },
  { value: 'Signature Select', label: 'Signature Select' },
  { value: 'Sol de Oro', label: 'Sol de Oro' },
  { value: 'Sunny Select', label: 'Sunny Select' },
  { value: 'Tortilleria Santacruz', label: 'Tortilleria Santacruz' },
  { value: 'Vallarta Supermarkets', label: 'Vallarta Supermarkets' },
]

export const packagingInitialState = {
  category: BSCornTortillaProduct.category,
  subCategory: BSCornTortillaProduct.subCategory,
  Size: BSCornTortillaProduct.Size,
}
